var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleGLogoColor(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.243c3.906 0 6.54 1.687 8.043 3.097l5.87-5.732C34.308 5.257 29.616 3.2 24 3.2 15.865 3.2 8.84 7.87 5.419 14.663l6.725 5.223C13.831 14.871 18.5 11.243 24 11.243z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.968 24.462c0-1.71-.139-2.958-.439-4.252H24v7.719h11.463c-.23 1.918-1.479 4.807-4.252 6.748l6.563 5.085c3.93-3.629 6.194-8.967 6.194-15.3z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.167 28.114A12.805 12.805 0 0111.474 24c0-1.433.254-2.82.67-4.114L5.42 14.663A20.818 20.818 0 003.2 24c0 3.351.809 6.517 2.219 9.337l6.748-5.223z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44.8c5.616 0 10.33-1.849 13.774-5.038l-6.563-5.085c-1.757 1.225-4.114 2.08-7.21 2.08-5.501 0-10.17-3.628-11.834-8.643l-6.725 5.223C8.862 40.132 15.865 44.8 24 44.8z",
    fill: "#34A853"
  })));
}
export default SvgGoogleGLogoColor;